import {
  SystemsEngineerDashboard as SystemsEngineerDashboardFeature,
  SystemsEngineerEventName
} from '@features/systems-engineer-dashboard'
import {PermissionType} from '@hconnect/apiclient'
import {useParams} from 'react-router'

import {useTrackSystemsEngineerAnalyticsEvent} from '../../performanceDashboard/helpers'
import {SystemsEngineerDashboardTitle} from '../components'
import {getCockpitShiftEventByIdAndTypeLink, getCockpitShiftEventsByTypeLink} from '../utils'

type PathParameter = {
  plantId: string
}

type Props = {
  permission: PermissionType
}

export const SystemsEngineerDashboard = ({permission}: Props) => {
  const {plantId} = useParams<PathParameter>()
  if (!plantId) throw new Error('plantId is missing')

  const trackSystemsEngineerDashboard = useTrackSystemsEngineerAnalyticsEvent()

  const handleEnterDashboard = () => {
    trackSystemsEngineerDashboard(SystemsEngineerEventName.UserEntersSystemsEngineerDashboard, {})
  }

  const handleSystemChangeRequestClick = (eventId: string) => {
    const url = getCockpitShiftEventByIdAndTypeLink({
      plantId,
      eventId,
      timeRange: 'rolling12months',
      eventType: 'systemChangeRequest'
    })
    window.location.assign(url)
  }

  const systemChangeRequestsLink = getCockpitShiftEventsByTypeLink({
    plantId,
    timeRange: 'rolling12months',
    eventType: 'systemChangeRequest'
  })

  return (
    <SystemsEngineerDashboardFeature
      plantId={plantId}
      titleSlot={<SystemsEngineerDashboardTitle permission={permission} />}
      onEnterDashboard={handleEnterDashboard}
      onSystemChangeRequestClick={handleSystemChangeRequestClick}
      systemChangeRequestsLink={systemChangeRequestsLink}
    />
  )
}
